import Article1 from "../images/article1.jpg";
import Article2 from "../images/article2.jpg";
import Article3 from "../images/article3.jpg";
import Article4 from "../images/article4.jpeg";
import Article5 from "../images/article5.jpg";
import Article6 from "../images/article6.jpg";
import Article7 from "../images/article7.jpg";
import Article8 from "../images/article8.JPG";
import Article9 from "../images/article9.jpg";
import Article10 from "../images/article10.JPG";
import Article11 from "../images/article11.jpg";
import Article12 from "../images/article12.png";

export const articledata = {
    "0" : {
        article_source: Article1,
        article_title: "Stop system spreading",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs19891012-01.2.20&srpos=68&e=------198-en-20-cs-61--txt-txIN-gate------",
        article_date: "October 12, 1989"
    },
    "1" : {
        article_source: Article2,
        article_title: "Secure Yourself",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs19961125-01.2.11&srpos=29&e=------199-en-20-cs-21--txt-txIN-gate------",
        article_date: "November 25, 1996"
    },
    "2" : {
        article_source: Article3,
        article_title: "Swipe Access for All",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20001116-01.2.17&srpos=40&e=-------en-20-cs-21--txt-txIN-swipe+access------",
        article_date: "November 16, 2000"
    },
    "3" : {
        article_source: Article4,
        article_title: "Barnard Students Do Not Need Columbia Swipe Access",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20010221-01.2.18&srpos=1&e=-------en-20-cs-1--txt-txIN-swipe+access------",
        article_date: "February 21, 2001"
    },
    "4" : {
        article_source: Article5,
        article_title: "No Excuses, Just Swipe",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20041208-01.2.17&srpos=3&e=-------en-20-cs-1--txt-txIN-swipe+access------",
        article_date: "December 8, 2004"
    },
    "5" : {
        article_source: Article6,
        article_title: "Swipe, Not Swastikas",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20041116-01.2.31&srpos=53&e=-------en-20-cs-41--txt-txIN-swipe+access------",
        article_date: "November 16, 2004"
    },
    "6" : {
        article_source: Article7,
        article_title: "Finances, Liabilities Make Flash Access Our Best Bet",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20060126-01.2.20&srpos=39&e=-------en-20-cs-21--txt-txIN-swipe+access------",
        article_date: "January 26, 2006"
    },
    "7" : {
        article_source: Article8,
        article_title: "Hacking Lessons: Personal information should be better protected",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20060908-01.2.26&srpos=135&e=-------en-20-cs-121--txt-txIN-swipe+access------",
        article_date: "September 8, 2006"
    },
    "8" : {
        article_source: Article9,
        article_title: "Undergraduate councils must take universal swipe access seriously",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20080222-01.2.16&srpos=5&e=-------en-20-cs-1--txt-txIN-swipe+access------",
        article_date: "February 22, 2008"
    },
    "9" : {
        article_source: Article10,
        article_title: "Not enough is done for GS swipe access",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20091119-01.2.27&srpos=54&e=-------en-20-cs-41--txt-txIN-swipe+access------",
        article_date: "November 19, 2009"
    },
    "10" : {
        article_source: Article11,
        article_title: "In the waiting line",
        article_link: "https://archive-publications.library.columbia.edu/?a=d&d=cs20111021-01.2.18&srpos=16&e=------201-en-20-cs-1--txt-txIN-swipe+access------",
        article_date: "October 21, 2011"
    },
    "11" : {
        article_source: Article12,
        article_title: "Pandemic to public safety: The shifting purpose of campus swipe access",
        article_link: "https://www.columbiaspectator.com/opinion/2024/04/12/pandemic-to-public-safety-the-shifting-purpose-of-campus-swipe-access/",
        article_date: "April 12, 2024"
    }
    
}